import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingProps {
  size?: number;
  text?: string;
}

export default function Loading({ size = 24, text = 'Loading...' }: LoadingProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <Loader2 className="animate-spin" size={size} />
      <p className="mt-4 text-gray-600">{text}</p>
    </div>
  );
} 